import React from 'react'
import { Snackbar, Button, Box } from '@mui/material'
import { focusStyle } from '../../../styles/common'
import {
	isChromeOnIos,
	isIos,
	isMacSafari,
	isMacChrome
} from '../../../utils/deviceUtils'

const InstallPromptSnackbar = ({ isVisible, onInstall, onDismiss, theme }) => (
	<Snackbar
		anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
		open={isVisible}
		message={
			<Box
				sx={{
					display: 'flex',
					flexDirection: 'column',
					alignItems: 'center',
					textAlign: 'center'
				}}
			>
				{isChromeOnIos() ? (
					<>
						<span>Save this tool to your home screen.</span>
						<span>
							You can switch to <strong>Safari</strong> to save this tool.
						</span>
						<span style={{ marginTop: 8 }}>
							Open this page in <strong>Safari</strong>, tap{' '}
							<strong>Share</strong>, and then{' '}
							<strong>Add to Home Screen</strong>.
						</span>
					</>
				) : isMacChrome() ? (
					<>
						<span>Save this tool to your home screen.</span>
						<span style={{ marginTop: 8 }}>
							Click the <strong>Install</strong> icon in the address bar, or go
							to <strong>More Tools → Create Shortcut</strong> and check{' '}
							<strong>&quot;Open as Window&quot;</strong>.
						</span>
					</>
				) : isMacSafari() ? (
					<>
						<span>Save this tool to your home screen.</span>
						<span style={{ marginTop: 8 }}>
							Go to <strong>File</strong> in the Safari menu and select{' '}
							<strong>Add to Dock</strong>.
						</span>
					</>
				) : isIos() ? (
					<>
						<span>Save this tool to your home screen.</span>
						<span style={{ marginTop: 8 }}>
							Tap <strong>Share</strong> and then{' '}
							<strong>Add to Home Screen</strong>.
						</span>
					</>
				) : (
					<span>Save this tool to your home screen.</span>
				)}
				<Box
					sx={{
						display: 'flex',
						gap: 1,
						marginTop: 2
					}}
				>
					{!isMacSafari() && !isMacChrome() && !isIos() && (
						<Button
							disableRipple
							size="small"
							sx={{
								marginRight: 1,
								backgroundColor: theme.palette.primary.main,
								color: '#FFFFFF',
								textTransform: 'none',
								'&:hover, &:active, &:focus': {
									backgroundColor: theme.palette.primary.main,
									color: '#FFFFFF'
								},
								...focusStyle
							}}
							onClick={onInstall}
						>
							Save
						</Button>
					)}
					<Button
						disableRipple
						size="small"
						sx={{
							backgroundColor: '#FFFFFF',
							color: theme.palette.primary.main,
							border: `1px solid ${theme.palette.primary.main}`,
							textTransform: 'none',
							'&:hover, &:active, &:focus': {
								backgroundColor: '#FFFFFF',
								color: theme.palette.primary.main,
								border: `1px solid ${theme.palette.primary.main}`
							},
							...focusStyle
						}}
						onClick={onDismiss}
					>
						Dismiss
					</Button>
				</Box>
			</Box>
		}
		ContentProps={{
			sx: {
				border: `2px solid ${theme.palette.primary.main}`,
				fontWeight: 'bold',
				textAlign: 'center',
				color: theme.palette.primary.main,
				backgroundColor: '#FFFFFF',
				'& .MuiSnackbarContent-message': {
					width: '100%'
				}
			}
		}}
	/>
)

export default InstallPromptSnackbar
